import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { createProjectUrl } from 'helpers/nexus'

import FormattedMessage from 'components/FormattedMessage'

const RedirectToNexus = ({ provider }) => {
  useEffect(() => {
    window.location.href = createProjectUrl(provider?.id)
  }, [provider])

  return (
    <div>
      <FormattedMessage id="contactRequest.redirectingToNexus.message" />
    </div>
  )
}

RedirectToNexus.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
}

export default RedirectToNexus
